import React from 'react'
import { makeStyles } from 'tss-react/mui'
import type { Theme } from '@mui/material/styles'
import { sideBarWidth, appBarHeight } from 'ui/theme'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    height: `calc(100vh - ${appBarHeight}px)`,
    justifyContent: 'space-between',
    position: 'relative',
  },
  sidebar: {
    backgroundColor: theme.palette.background.paper,
    width: sideBarWidth,
    overflow: 'hidden',
    display: 'flex',
    flex: 1,
    minWidth: 240, // NOTE: iPadでの縦表示想定
  },
  main: {
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    width: `calc(100% - ${sideBarWidth}px)`,
    borderLeft: `1px solid ${theme.palette.divider}`,
    minWidth: 500, // NOTE: iPadでの縦表示想定
  },
  content: {
    flex: 1,
    overflow: 'auto',
    width: '100%',
    display: 'flex',
    padding: theme.spacing(2),
    flexDirection: 'column',
  },
  controlBar: {
    display: 'flex',
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}))

export const useStylesInnerAdminContentWrapper = makeStyles()(
  (theme: Theme) => ({
    // NOTE: controlBarにHookFormの送信ボタンを含む場合にAdminContentWrapperのcontrolBarと同等のものをAdminContentWrapperのcontentの中に表示する
    // TODO: コンポーネント化してStoryで再現する
    // TODO: controlBarを本来の場所に置くことができればこれらのdivは不要
    root: {
      height: '100%',
      width: `calc(100% + ${theme.spacing(2)})`,
      marginTop: theme.spacing(-2),
      marginRight: theme.spacing(-2),
    },
    main: {
      display: 'flex',
      height: `calc(100vh - ${
        appBarHeight + Number(theme.spacing(4).slice(0, -2))
      }px)`,
      width: '100%',
      flexDirection: 'column',
    },
    content: {
      flex: 1,
      overflow: 'auto',
      width: '100%',
      display: 'flex',
      padding: theme.spacing(2, 2, 3, 0),
      flexDirection: 'column',
    },
    controlBar: {
      display: 'flex',
      backgroundColor: theme.palette.background.paper,
      borderTop: `1px solid ${theme.palette.divider}`,
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(2),
      marginLeft: theme.spacing(-2),
      marginBottom: theme.spacing(-4),
    },
  })
)

export type LayoutProps = {
  sidebar: any
  children: any
  controlBar?: any
}

/**
 * サイドバー、コンテンツのあるレイアウト、それぞれスクロールする
 */
const AdminContentWrapper: React.FC<LayoutProps> = ({
  sidebar,
  controlBar,
  children,
}: LayoutProps) => {
  const { classes } = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.sidebar}>{sidebar}</div>
      <div className={classes.main}>
        <div className={classes.content}>{children}</div>
        {controlBar && <div className={classes.controlBar}>{controlBar}</div>}
      </div>
    </div>
  )
}

export default AdminContentWrapper
